<template>
    <div>
        <vx-card>
            <div slot="no-body" class="tabs-container px-6 pt-6">
                <div class="vx-row">
                    <h3 class="ml-2">Thông tin công việc</h3>
                </div>
                <div class="vx-row mb-4">
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <vs-input class="w-full" label="Mã nhân viên" :disabled="true"
                                  v-model="employeeInfo.employeeCode"
                                  v-validate="'required'" name="employeeCode"/>
                        <span class="text-danger text-sm">{{ errors.first('employeeCode') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <vs-input class="w-full" label="Họ tên" :disabled="true"
                                  v-model="employeeInfo.fullName"
                                  v-validate="'required'" name="fullName"/>
                        <span class="text-danger text-sm">{{ errors.first('fullName') }}</span>
                    </div>
                </div>

                <div class="vx-row mt-3">
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">Địa điểm</label>
                        <v-select class="" v-model="placeModel" :clearable="false" :options="placeOptions"
                                  data-vv-validate-on="blur" v-validate="'required'" name="place"/>
                        <span class="text-danger text-sm">{{ errors.first('place') }}</span>
                    </div>
                    <div class="vx-col md:w-1/3 w-full mt-2">
                        <label class="vs-input--label">Khu vực</label>
                        <v-select class="" v-model="areaModel" :clearable="false" :options="areaOptions"
                                  data-vv-validate-on="blur" v-validate="'required'" name="area"/>
                        <span class="text-danger text-sm">{{ errors.first('area') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-4">
                    <div class="vx-col md:w-1/6 w-full mt-2">
                        <small class="date-label">Thời gian bắt đầu</small>
                        <v-select :value="employeeInfo.fromHourString" :clearable="false" :options="timeSpans"
                                  @input="fromHour => updateTimeSpan(employeeInfo, fromHour, 'fromHour')"/>
                    </div>
                    <div class="vx-col md:w-1/6 w-full mt-2">
                        <small class="date-label">Thời gian kết thúc</small>
                        <v-select :value="employeeInfo.toHourString" :clearable="false" :options="timeSpans"
                                  @input="toHour => updateTimeSpan(employeeInfo, toHour, 'toHour')"/>
                    </div>
                    <div class="vx-col md:w-1/6 w-full mt-2">
                        <small class="date-label">Ngày làm việc</small>
                        <vs-checkbox style="margin-bottom: 5px" v-model="checkBox2">Thứ 2</vs-checkbox>
                        <vs-checkbox style="margin-bottom: 5px" v-model="checkBox3">Thứ 3</vs-checkbox>
                        <vs-checkbox style="margin-bottom: 5px" v-model="checkBox4">Thứ 4</vs-checkbox>
                        <vs-checkbox style="margin-bottom: 5px" v-model="checkBox5">Thứ 5</vs-checkbox>
                        <vs-checkbox style="margin-bottom: 5px" v-model="checkBox6">Thứ 6</vs-checkbox>
                        <vs-checkbox style="margin-bottom: 5px" v-model="checkBox7">Thứ 7</vs-checkbox>
                        <vs-checkbox style="margin-bottom: 5px" v-model="checkBox8">Chủ nhật</vs-checkbox>
                    </div>
                </div>

                <!-- Save & Reset Button -->
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <div class="mt-8 flex flex-wrap items-center justify-end mb-5">
                            <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm">{{
                                    `${isUpdate ?
                                        'Cập nhật' : 'Tạo mới'}`
                                }}
                            </vs-button>
                            <vs-button class="ml-4 mt-2" type="border" color="warning" @click="$router.go(-1)">Quay lại
                            </vs-button>
                        </div>
                    </div>
                </div>
            </div>
        </vx-card>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';
import utils from "../../../components/utils";

export default {
    components: {
        vSelect,
        Datepicker
    },
    data() {
        return {
            user_data: null,
            activeTab: 0,
            isUpdate: false,
            employeeInfo: {},
            placeOptions: [],
            areaOptions: [],
            checkBox2: false,
            checkBox3: false,
            checkBox4: false,
            checkBox5: false,
            checkBox6: false,
            checkBox7: false,
            checkBox8: false,
        }
    },
    created() {
        let timeDuration = 30, timeSpans = [];
        for (let i = 0; i < 24 * 60; i = i + timeDuration) {
            timeSpans.push({value: i, label: utils.minuteToHour(i)});
        }
        this.timeSpans = timeSpans;

        this.loadPlace();
        let employeeId = this.$route.query.id;
        let that = this;
        if (employeeId) {
            setTimeout(() => {
                this.$vs.loading();
                this.$crm.post('/daily-work/employee/find-by-employee/' + employeeId).then((response) => {
                    this.$vs.loading.close();
                    response.data.fromHourString = utils.minuteToHour(response.data.dailyWorkSetting.length > 0 ? response.data.dailyWorkSetting[0].fromHour : null);
                    response.data.fromHour = response.data.dailyWorkSetting.length > 0 ? response.data.dailyWorkSetting[0].fromHour : null;
                    response.data.toHourString = utils.minuteToHour(response.data.dailyWorkSetting.length > 0 ? response.data.dailyWorkSetting[0].toHour : null);
                    response.data.toHour = response.data.dailyWorkSetting.length > 0 ? response.data.dailyWorkSetting[0].toHour : null;

                    if (response.data.dailyWorkSetting.length > 0) {
                        let dailyWorkSetting = response.data.dailyWorkSetting[0].workDayOfWeek.split(',')
                        dailyWorkSetting.forEach(work => {
                            if (work == "2") this.checkBox2 = true;
                            if (work == "3") this.checkBox3 = true;
                            if (work == "4") this.checkBox4 = true;
                            if (work == "5") this.checkBox5 = true;
                            if (work == "6") this.checkBox6 = true;
                            if (work == "7") this.checkBox7 = true;
                            if (work == "8") this.checkBox8 = true;
                        });
                    }

                    response.data.areaId = response.data.dailyWorkSetting.length > 0 && response.data.dailyWorkSetting[0].areaId ? response.data.dailyWorkSetting[0].areaId : null;
                    response.data.buildingId = response.data.dailyWorkSetting.length > 0 && response.data.dailyWorkSetting[0].buildingId ? response.data.dailyWorkSetting[0].buildingId : null;
                    this.employeeInfo = response.data;
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }).finally(() => {
                    if (that.employeeInfo.buildingId) {
                        that.loadAreaByPlace(that.employeeInfo.buildingId);
                    }
                });
            });
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any()
        },
        placeModel: {
            get() {
                return {
                    label: this.getLabelString(this.placeOptions.find(x => x.value == this.employeeInfo.buildingId)),
                    value: this.employeeInfo.buildingId
                }
            },
            set(obj) {
                this.employeeInfo.buildingId = obj.value
                this.loadAreaByPlace(this.employeeInfo.buildingId);
            }
        },
        areaModel: {
            get() {
                return {
                    label: this.getLabelString(this.areaOptions.find(x => x.value == this.employeeInfo.areaId)),
                    value: this.employeeInfo.areaId
                }
            },
            set(obj) {
                this.employeeInfo.areaId = obj.value
            }
        },
    },
    methods: {
        updateTimeSpan(setting, hour, type) {
            setting[type] = hour.value;
            setting[`${type}String`] = hour.label;
        },
        loadPlace() {
            return new Promise((resolve) => {
                this.$crm.get('/building-type/find-all').then((place) => {
                    this.placeOptions = place.data.map(place => {
                        return {
                            label: place.name,
                            value: place.id
                        }
                    });
                    resolve();
                })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        loadAreaByPlace(id) {
            let that = this;
            return new Promise((resolve) => {
                that.$crm.get('/area/find-by-place_id/' + id).then((response) => {
                    that.areaOptions = response.data.map(area => {
                        return {
                            label: area.name,
                            value: area.id
                        }
                    });
                    resolve();
                })
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },
        async saveChanges(evt) {
            evt.preventDefault();
            try {
                if (!this.validateForm) return;

                const result = await this.$validator.validateAll();
                if (!result) return;
                if (!this.employeeInfo.buildingId) {
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: "Địa điểm làm việc chưa được chọn",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                if (!this.employeeInfo.areaId) {
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: "Khu vực làm việc chưa được chọn",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                if (this.employeeInfo.fromHour == undefined) {
                    this.employeeInfo.fromHour = 0;
                }
                if (this.employeeInfo.toHour == undefined) {
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: "Thời gian kết thúc chưa được chọn",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }

                if (this.employeeInfo.fromHour >= this.employeeInfo.toHour) {
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: "Thời gian kết thúc phải lớn hơn bắt đầu.",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }

                delete this.employeeInfo.fromHourString;
                delete this.employeeInfo.toHourString;

                if (!this.checkBox2 && !this.checkBox3 && !this.checkBox4 && !this.checkBox5 &&
                    !this.checkBox6 && !this.checkBox7 && !this.checkBox8) {
                    return this.$vs.notify({
                        title: 'Có lỗi sảy ra!',
                        text: "Ngày làm việc chưa được chọn",
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                }
                let workDayOfWeek = [];
                if (this.checkBox2) workDayOfWeek.push(2);
                if (this.checkBox3) workDayOfWeek.push(3);
                if (this.checkBox4) workDayOfWeek.push(4);
                if (this.checkBox5) workDayOfWeek.push(5);
                if (this.checkBox6) workDayOfWeek.push(6);
                if (this.checkBox7) workDayOfWeek.push(7);
                if (this.checkBox8) workDayOfWeek.push(8);
                this.employeeInfo.workDayOfWeek = workDayOfWeek.join(",");

                this.employeeInfo.dailyWorkSetting = [{
                    buildingId: this.employeeInfo.buildingId,
                    areaId: this.employeeInfo.areaId,
                    autoGenerateWork: 1
                }];

                this.employeeInfo.fullName = this.employeeInfo.firstName.trim() + " " + this.employeeInfo.lastName.trim();
                let url = `/daily-work/organization/register-employee-daily-work/${this.$route.query.branch_id}`,
                    data = [this.employeeInfo];

                this.$vs.loading();
                this.$crm.post(url, data).then(() => {
                    this.$vs.loading.close();
                    this.$vs.notify({
                        color: 'success',
                        text: `Đăng ký thành công`,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                    });
                    this.$router.push(`/user/register-daily-work?${this.employeeInfo.organizationBranchId ? `?branch_id=${this.employeeInfo.organizationBranchId}` : ''}`).catch(() => {
                    })
                }).catch((err) => {
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            } catch (ex) {
                console.log(ex);
            }
        },

        handleFileUpload() {
            this.file = this.$refs.fileInput.files[0];

            if (!this.file) return;

            if (this.file.length > 1)
                return this.$vs.notify({
                    text: 'Chỉ cho phép upload 1 file!',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning'
                });

            this.fileName = this.file.name;
        }
    },
}
</script>

<style scoped>

</style>
